import { Component, Injectable } from '@angular/core';

@Injectable()
export class RouteDataService {

  private transfers: { [key: string]: any }[] = [];

  /**
   * Armazena os dados a serem transferidos de um componente para outro.
   *
   * @param id   Chave que representa o identificador da transferência a ser executada
   * @param data Os dados a serem transferidos
   */
  transfer(id: string, data: any): void {
    this.transfers[id] = data;
  }

  /**
   * Recupera os dados armazenados de uma transferência de um componente para outro.
   *
   * @param id Chave que representa o identificador da transferência executada
   *
   * @return Os dados transferidos
   */
  retrieve(id: string): any {
    const data = this.transfers[id] || null;
    return data;
  }

  /**
   * Remove os dados referentes a uma transferência feita entre dois componentes.
   *
   * @param id Chave que representa o identificador da transferência executada
   */
  remove(id: string): void {
    this.transfers[id] = null;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/api/route-data.service.ts